import { RootState } from 'app/store'

import { IQRASavedStateViewInfo } from './types'

export const selectSavedStateViewInfo = (
  state: RootState
): IQRASavedStateViewInfo | undefined =>
  state.riskManagement.savedState.stateViewInfo

export const selectSavedStateDetailsId = (state: RootState) =>
  state.riskManagement.savedState.detailsId
